import { Skeleton as MuiSkeleton, Stack } from '@mui/material';

interface SkeletonProps {
  count: number;
  rowHeight?: number | string;
  gap?: number | string;
}

const Skeleton = ({ count, rowHeight = '48px', gap = '4px' }: SkeletonProps) => (
  <Stack gap={gap}>
    {Array.from({ length: count }).map((_, index) => (
      <MuiSkeleton key={index} variant="rounded" width="100%" height={rowHeight} />
    ))}
  </Stack>
);

export default Skeleton;
